// Hebrew labels for a document line's classification (items.line_kind /
// adjustment_type). Sync pair: server/lib/lineKind.js owns the values — the
// keys here must be exactly its LINE_KINDS and ADJUSTMENT_TYPES.
export const LINE_KIND_ADJUSTMENT = 'adjustment';

// The UI never says "adjustment": a line that only moves the amount is
// לא מוצר, with its sub-type (הנחה, דמי משלוח…) under it.
export const LINE_KIND_LABELS = Object.freeze({
  product: 'מוצר',
  service: 'שירות',
  adjustment: 'לא מוצר',
});

export const LINE_KINDS = Object.freeze(Object.keys(LINE_KIND_LABELS));

export const ADJUSTMENT_TYPE_LABELS = Object.freeze({
  discount: 'הנחה',
  delivery_fee: 'דמי משלוח',
  deposit: 'פיקדון',
  purchase_tax: 'מס קנייה',
  vat: 'מע״מ',
  rounding: 'עיגול',
  other: 'אחר',
});

export const ADJUSTMENT_TYPES = Object.freeze(Object.keys(ADJUSTMENT_TYPE_LABELS));

// The document editor's lines as PUT /documents/:id takes them. The server
// deletes and re-inserts every line, so a line's own id can't be sent as its
// id — it rides as source_item_id, which is how the server puts the admin's
// marks back on the same lines (carryOverLineKinds). The marks themselves are
// never sent: only the Command Center sets them.
export function itemsForSave(items) {
  return (items || []).map(({ _key, id, document_id, line_kind, adjustment_type, ...rest }) => (
    id != null ? { ...rest, source_item_id: id } : rest
  ));
}

// The pill on a classified line: "מוצר", "שירות", "לא מוצר" or
// "לא מוצר · הנחה". '' for an unclassified line.
export function lineKindLabel(kind, adjustmentType) {
  const label = LINE_KIND_LABELS[kind];
  if (!label) return '';
  const sub = kind === LINE_KIND_ADJUSTMENT ? ADJUSTMENT_TYPE_LABELS[adjustmentType] : null;
  return sub ? `${label} · ${sub}` : label;
}

// The summary after a classification: `moved` = lines per class before the
// change; all of them are now in `toKind` ('' = unclassified).
export function patchSummary(summary, moved, toKind) {
  if (!summary) return summary;
  const next = { ...summary };
  const to = toKind || 'unclassified';
  for (const [from, n] of Object.entries(moved)) {
    if (!(from in next) || !(to in next)) continue;
    next[from] -= n;
    next[to] += n;
  }
  return next;
}
